import './polyfills';
import './ui/tokens.css';
import './ui/styles.css';
// Brand direction C (vite.config.ts "brand"; production since 2026-10-18); empty in a classic build.
import 'virtual:brand.css';
import 'virtual:flow-d.css';
import './ui/icons.css';
import { registerServiceWorker } from './pwa/register';
import { loadLang, mountApp } from './ui/app';
import { isDevMode } from './ui/devMode';
import { loadLanguage } from './i18n';
import { BUILD_ID } from './diagnostics/buildInfo';
import { buildAnimalLabel } from './build/indicator';

console.info(`Magia Li ${BUILD_ID} (${buildAnimalLabel(BUILD_ID)})`);

const root = document.getElementById('app');
if (!root) throw new Error('#app element missing from index.html');
// The starting language's messages first (only Hebrew and English are in the main bundle).
await loadLanguage(loadLang());
const app = mountApp(root);
// ?dev only (src/ui/devMode.ts): show the "new version" prompt now, so the layout tests can check it
// (tests/ui/overlap.browser.test.ts); normally only the service worker shows it, after a deploy.
if (isDevMode(location.search, import.meta.env.DEV)) Object.assign(window, { magiaShowUpdateNotice: () => app.showUpdateNotice() });
registerServiceWorker({
  hasUnsavedData: () => app.hasUnsavedData(),
  showNotice: () => app.showUpdateNotice(),
  reload: () => location.reload(),
}, BUILD_ID);
